/* registerIcons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("form.launch", require("./rawicons/form/launch.icon.svg.js"));
IconRegistry.registerIcon(
    "wizard.wizardEditor",
    require("./rawicons/wizard/wizardEditor.icon.svg.js")
);
